module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACBSURBVDhP1VNBDoAgDJPHAj+TH6g/wFeB7TINLoSDnmhSl7TdBMQlhLCCBawtvff7ArBaD2Q+sbkg4xhsofpTDZzoeFQVXrj1oT9pc4yRp9k77VND2Xog84dM+Qy8edNJdnqmz2p0snDF4z011UL0eZt/3e3uXwXKd9R7YD3kQ7oAlAHN2OTGFSkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./app/img/5.png
// module id = 81
// module chunks = 0